/* eslint-disable no-unreachable */
/* eslint-disable react/prop-types */
import {
  Divider,
  Link as MUILink,
  Stack, Typography
} from '@mui/material';
import Link from 'next/link';
import Image from './Image';

export default function AppSection() {
  return (
    <Stack direction={"row"} my={1} p={1} spacing={2} alignItems={"center"}>
      <Link href={"/tai-app/"} passHref>
        <MUILink>
          <Image src={"/icons/qr.jpg"} sx={{ cursor: 'pointer' }} alt="tải app" />
        </MUILink>
      </Link>
      <Stack >
        <Link href="/tai-app/" target="_blank" passHref>
          <MUILink>
            <Image src={"/icons/ic_ios.jpg"} alt="ios" />
          </MUILink>
        </Link>
        <Link href="/tai-app/" target="_blank" passHref>
          <MUILink>
            <Image src={"/icons/ic_android.jpg"} alt="android" />
          </MUILink>
        </Link>
      </Stack>
    </Stack>);
}

export function AppDownload() {
  return (<>
    <Divider sx={{ mb: 3 }} />
    <Typography variant="subtitle1">Tải App di động và chia sẻ</Typography>
    <Divider />
    <Stack direction={"row"} my={2} spacing={1} alignItems={"center"}>
      <Link href="/tai-app/" target="_blank" passHref>
        <Image src={"/icons/qr.jpg"} alt="" sx={{ width: 50, height: 60, cursor: 'pointer' }} />
      </Link>
      <Link href="/tai-app/" target="_blank" passHref>
        <Image src={"/icons/ic_ios.jpg"} alt="" sx={{ width: 120, height: 50, cursor: 'pointer' }} />
      </Link>
      <Link href="/tai-app/" target="_blank" passHref>
        <Image src={"/icons/ic_android.jpg"} alt="" sx={{ width: 130, height: 50, cursor: 'pointer' }} />
      </Link>
    </Stack>
  </>);
}